export default __webpack_public_path__ + "static/race-day-pet-square-89434c1de27c187062a0ddd6b93336c7.png";